<template>
    <!--    <form ref="form" @submit.prevent="save">-->
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">예약시간 설정</span>
            <span class="txt">
                센터의 수업시간 시작설정 및 회원예약 어플리케이션(App)에서 회원이 수업을 예약, 취소하는 시간을 설정할 수
                있습니다. 또한, 강사의 수업 예약시간 제한설정이 가능합니다.
            </span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingReservationTime' }">수업시간</router-link>
            <router-link :to="{ name: 'SettingReservationApp' }">회원예약 앱</router-link>
            <router-link :to="{ name: 'SettingReservationTeacher' }" class="on">강사수업 예약</router-link>
        </div>

        <p class="sub-title small">
            강사가 스케줄을 언제까지 예약/취소할 수 있는지 제한하는 기능입니다.
            <br />
            제한시간 이내에 예약하지 않은 경우, 이미 지난 수업에 대한 예약은 불가능합니다.
            <br />
            <!--            <span class="red">설정하지 않을 경우 어떠한 제한도 받지 않습니다.</span>-->
        </p>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">예약 및 취소 가능시간</span>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w180">
                                <strong class="blue">개인 / OT</strong>
                                는 시작시간으로부터
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.teacherReservationOtDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.teacherReservationOtHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.teacherReservationOtMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 이후까지
                                <span class="red">예약 및 취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w180">
                                <strong class="blue">듀엣</strong>
                                은 시작시간으로부터
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.teacherReservationDuDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.teacherReservationDuHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.teacherReservationDuMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 이후까지
                                <span class="red">예약 및 취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w180">
                                <strong class="blue">그룹</strong>
                                은 시작시간으로부터
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.teacherReservationGrDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.teacherReservationGrHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.teacherReservationGrMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 이후까지
                                <span class="red">예약 및 취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w180">
                                <strong class="blue">쿠폰</strong>
                                은 시작시간으로부터
                            </span>
                            <select-form
                                :select-data="optionsDays"
                                :select-value="valuesDays"
                                :selected-value.sync="data.teacherReservationCpDay"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">일</span>
                            <select-form
                                :select-data="optionsHours"
                                :select-value="valuesHours"
                                :selected-value.sync="data.teacherReservationCpHour"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">시간</span>
                            <select-form
                                :select-data="optionsMinutes"
                                :select-value="valuesMinutes"
                                :selected-value.sync="data.teacherReservationCpMinute"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            ></select-form>
                            <span class="txt">
                                분 이후까지
                                <span class="red">예약 및 취소</span>
                                가 가능합니다.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="bottom-btn">
            <button class="com-btn blue" type="submit" @click="save">저장</button>
        </div>
        <!--    </form>-->
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingReservationTeacher',
    components: { LoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            fields: ['teacherReservationCp', 'teacherReservationDu', 'teacherReservationGr', 'teacherReservationOt'],
            optionsDays: _.range(0, 61).map((v) => String(v)),
            valuesDays: _.range(0, 61).map((v) => String(v)),
            optionsHours: _.range(0, 24).map((v) => String(v)),
            valuesHours: _.range(0, 31).map((v) => String(v)),
            optionsMinutes: _.range(0, 60).map((v) => String(v)),
            valuesMinutes: _.range(0, 60).map((v) => String(v)),
            isLoading: false,
            data: {},
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        setPart(key) {
            const matches = [...this.data[key].matchAll(/(\d+)-(\d+)-(\d+)/g)][0] || [];
            this.data[`${key}Day`] = Number(matches[1] || '0').toString();
            this.data[`${key}Hour`] = Number(matches[2] || '0').toString();
            this.data[`${key}Minute`] = Number(matches[3] || '0').toString();
        },
        getPartSum(key) {
            this.data[key] = `${this.data[`${key}Day`].padStart(2, '0')}-${this.data[`${key}Hour`].padStart(
                2,
                '0'
            )}-${this.data[`${key}Minute`].padStart(2, '0')}`;
        },
        load() {
            api.get(`/admin/api/center/${this.centerId}/reservation-setting`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data || {};
                    _.each(this.data, (i, k) => {
                        if (k.search(/^teacher/) >= 0) {
                            this.data[k] = String(i || 0);
                        }
                    });
                    this.fields.forEach((k) => this.setPart(k));
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404 || this.prodNo) {
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    }
                    console.error(res);
                });
        },
        save() {
            // if (!this.$refs.form.checkValidity() || this.isLoading) {
            //     return;
            // }

            const error = false;

            this.fields.forEach((k) => this.getPartSum(k));

            if (error) return;

            this.isLoading = true;

            // 스웨거 검색: 센터예약시간설정 조회
            api.post(`/admin/api/center/${this.centerId}/reservation-setting`, this.data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    this.load();
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
    },
};
</script>
<style lang="scss"></style>
